// extracted by mini-css-extract-plugin
export default {"container":"GN-z","topReviewHeading":"HN-z","criticalReview":"IN-z","favorableReview":"JN-z","vsSeparator":"KN-z"};